export const translateBuyerRegionText = (t, allowedBuyerRegion) => {
    switch (allowedBuyerRegion) {
        case 'Sweden':
            return t('vip_buyer_region_text_sweden');
        case 'Nordic':
            return t('vip_buyer_region_text_nordic');
        case 'EU':
            return t('vip_buyer_region_text_eu');
        case 'International':
            return t('vip_buyer_region_text_international');
        default:
            return allowedBuyerRegion;
    }
};
